export enum Level {
    ADMIN = 'admin',
    USER = 'user'
}